var _path, _path2, _path3, _path4, _path5, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22, _circle23, _circle24, _circle25, _circle26, _circle27, _circle28, _circle29, _circle30, _circle31, _circle32, _circle33, _circle34, _circle35, _circle36, _circle37, _circle38, _circle39, _circle40, _circle41, _circle42, _circle43, _circle44, _circle45, _circle46, _circle47, _circle48, _circle49, _circle50, _circle51, _circle52, _circle53, _circle54, _circle55, _circle56, _circle57, _circle58, _circle59, _circle60, _circle61, _circle62, _circle63, _circle64, _circle65, _circle66, _circle67, _circle68, _circle69, _circle70, _circle71, _circle72, _circle73, _circle74, _circle75, _circle76, _circle77, _circle78, _circle79, _circle80, _circle81, _circle82, _circle83, _circle84, _circle85, _circle86, _circle87, _circle88, _circle89, _circle90, _circle91, _circle92, _circle93, _circle94, _circle95, _circle96, _circle97, _circle98, _circle99, _circle100, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgScreenOfDeath = function SvgScreenOfDeath(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 286,
    height: 302,
    viewBox: "0 0 286 302",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M264.231 131.976C250.823 145.511 228.385 153.048 213.584 190.069C185.893 259.332 128.2 294.177 73.5018 225.069C18.7944 155.952 13.4602 81.3007 74.8672 47.4113C119.944 22.5335 149.064 46.9379 171.975 24.3996C214.621 -17.564 259.161 -1.7616 277.102 44.1434C295.044 90.0485 282.063 113.98 264.231 131.976Z",
    fill: "#FFD763"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M167.953 87.5752C158.922 90.1481 149.514 84.9106 146.945 75.8798C144.372 66.8453 149.609 57.4407 158.64 54.8678C167.675 52.2949 177.083 57.5323 179.652 66.5668C182.221 75.5976 176.984 85.0059 167.953 87.5752ZM206.056 86.494L209.079 74.4651L202.98 71.4634C202.995 69.7005 202.882 67.9229 202.651 66.138L208.643 62.9566L205.245 51.0304L197.747 51.5289C196.966 50.1545 196.105 48.8387 195.174 47.5889L199.114 41.2813L190.211 32.6499L183.552 37.1104C182.32 36.381 181.056 35.714 179.751 35.1239L180.03 27.2732L168.004 24.2495L164.409 31.5541C163.012 31.5138 161.612 31.5504 160.198 31.6604L156.496 24.6857L144.566 28.0796L145.094 35.9632C143.756 36.6522 142.473 37.4109 141.245 38.2282L134.817 34.2149L126.189 43.1174L130.28 49.2272C129.356 50.6126 128.52 52.053 127.776 53.5447L120.809 53.2991L117.785 65.3243L123.723 68.2454C123.58 70.1183 123.572 72.0131 123.704 73.9226L118.225 76.8328L121.619 88.759L127.509 88.3705C128.429 90.2947 129.491 92.1162 130.675 93.8315L127.751 98.5081L136.653 107.139L141.139 104.134C143.001 105.391 144.969 106.483 147.018 107.403L146.838 112.516L158.867 115.544L161.173 110.852C163.423 110.973 165.703 110.9 167.99 110.621L170.368 115.107L182.298 111.714L181.932 106.256C183.889 105.219 185.733 104.031 187.455 102.708L192.047 105.578L200.679 96.6756L197.311 91.6434C198.34 89.9281 199.246 88.1359 200.008 86.2814L206.056 86.494Z",
    fill: "#387BFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M168.479 91.1423C157.418 94.2943 145.891 87.8767 142.743 76.8117C139.587 65.7468 146.009 54.22 157.07 51.0717C168.135 47.9197 179.662 54.341 182.81 65.4059C185.962 76.4672 179.544 87.9903 168.479 91.1423ZM155.578 45.827C141.614 49.7999 133.518 64.3394 137.491 78.3034C141.468 92.2675 156.011 100.364 169.971 96.387C183.931 92.4141 192.031 77.8746 188.055 63.9106C184.082 49.9465 169.539 41.8503 155.578 45.827Z",
    fill: "#0063CB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M97.7519 191.777C83.8795 200.914 65.2242 197.073 56.0907 183.197C46.9536 169.314 50.802 150.662 64.6744 141.529C78.5504 132.395 97.2021 136.236 106.343 150.119C115.473 163.992 111.628 182.647 97.7519 191.777ZM161.473 169.728L160.194 147.821L148.312 145.993C147.388 143.013 146.26 140.07 144.925 137.185L153.34 128.631L141.286 110.309L128.891 115.132C126.838 113.23 124.69 111.467 122.458 109.847L125.764 97.1148L106.156 87.274L97.2828 98.3352C94.8162 97.7562 92.3276 97.3127 89.817 97.0011L86.1152 83.6089L64.2162 84.8917L62.0318 99.1196C59.6569 99.7976 57.3075 100.604 54.9875 101.539L45.0258 91.7381L26.704 103.8L31.7727 116.822C29.8852 118.691 28.1223 120.648 26.484 122.69L13.5059 119.322L3.66877 138.93L13.8174 147.066C12.9964 149.896 12.3514 152.773 11.8896 155.683L0 158.967L1.27912 180.87L12.8499 182.644C13.6049 185.88 14.5981 189.083 15.8332 192.232L8.12917 200.053L20.1947 218.378L29.9255 214.592C32.4948 217.348 35.2509 219.863 38.1647 222.124L35.7127 231.573L55.3174 241.41L61.2988 233.959C65.1105 235.088 69.0065 235.887 72.9502 236.356L75.3619 245.075L97.2644 243.799L98.6682 234.655C102.528 233.666 106.336 232.335 110.052 230.653L116.451 236.953L134.773 224.899L131.262 215.875C134.011 213.09 136.492 210.11 138.695 206.962L147.971 209.366L157.808 189.761L149.456 183.061C150.284 179.616 150.856 176.112 151.156 172.579L161.473 169.728Z",
    fill: "#C5E1F9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M102.293 197.352C85.2942 208.545 62.4423 203.835 51.2564 186.837C40.0558 169.841 44.7728 146.979 61.7679 135.789C78.7739 124.599 101.622 129.313 112.812 146.315C124.005 163.314 119.295 186.162 102.293 197.352ZM56.4645 127.729C35.0126 141.851 29.0678 170.684 43.1858 192.14C57.3111 213.592 86.1445 219.533 107.6 205.411C129.048 191.293 134.993 162.46 120.871 141.008C106.75 119.553 77.9127 113.612 56.4645 127.729Z",
    fill: "#EAF4FE"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 77.4727,
    y: 84.8748,
    width: 187.618,
    height: 119.335,
    rx: 20,
    transform: "rotate(15 77.4727 84.8748)",
    fill: "#9EADEB"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 67.7578,
    y: 165.516,
    width: 36.3749,
    height: 13.4013,
    rx: 6.70064,
    transform: "rotate(15 67.7578 165.516)",
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 150.355,
    y: 187.648,
    width: 36.3749,
    height: 13.4013,
    rx: 6.70064,
    transform: "rotate(15 150.355 187.648)",
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 109.055,
    y: 176.581,
    width: 36.3749,
    height: 13.4013,
    rx: 6.70064,
    transform: "rotate(15 109.055 176.581)",
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 191.656,
    y: 198.714,
    width: 36.3749,
    height: 13.4013,
    rx: 6.70064,
    transform: "rotate(15 191.656 198.714)",
    fill: "white"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 58.7148,
    y: 119.974,
    width: 187.618,
    height: 119.335,
    rx: 20,
    fill: "#CFD6F5"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 70.1992,
    y: 200.381,
    width: 36.3749,
    height: 13.4013,
    rx: 6.70064,
    fill: "white"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 155.715,
    y: 200.381,
    width: 36.3749,
    height: 13.4013,
    rx: 6.70064,
    fill: "white"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 112.957,
    y: 200.381,
    width: 36.3749,
    height: 13.4013,
    rx: 6.70064,
    fill: "white"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 198.473,
    y: 200.381,
    width: 36.3749,
    height: 13.4013,
    rx: 6.70064,
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 55.2704,
    cy: 55.4118,
    r: 1.02825,
    fill: "#7038A7"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 55.2704,
    cy: 59.0104,
    r: 1.02825,
    fill: "#7038A7"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 55.2704,
    cy: 62.6096,
    r: 1.02825,
    fill: "#7038A7"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 55.2704,
    cy: 66.2079,
    r: 1.02825,
    fill: "#7038A7"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 55.2704,
    cy: 69.8071,
    r: 1.02825,
    fill: "#7038A7"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 69.6689,
    cy: 55.4113,
    r: 1.02825,
    fill: "#7038A7"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 69.6689,
    cy: 59.0104,
    r: 1.02825,
    fill: "#7038A7"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 69.6689,
    cy: 62.6096,
    r: 1.02825,
    fill: "#7038A7"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 69.6689,
    cy: 66.2079,
    r: 1.02825,
    fill: "#7038A7"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 69.6689,
    cy: 69.8071,
    r: 1.02825,
    fill: "#7038A7"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 58.8681,
    cy: 55.4113,
    r: 1.02825,
    fill: "#7038A7"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 58.8681,
    cy: 59.0104,
    r: 1.02825,
    fill: "#7038A7"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 58.8681,
    cy: 62.6096,
    r: 1.02825,
    fill: "#7038A7"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 58.8681,
    cy: 66.2079,
    r: 1.02825,
    fill: "#7038A7"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 58.8681,
    cy: 69.8071,
    r: 1.02825,
    fill: "#7038A7"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 62.4697,
    cy: 55.4113,
    r: 1.02825,
    fill: "#7038A7"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 62.4697,
    cy: 59.0104,
    r: 1.02825,
    fill: "#7038A7"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 62.4697,
    cy: 62.6096,
    r: 1.02825,
    fill: "#7038A7"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 62.4697,
    cy: 66.2079,
    r: 1.02825,
    fill: "#7038A7"
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 62.4697,
    cy: 69.8071,
    r: 1.02825,
    fill: "#7038A7"
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: 66.0673,
    cy: 55.4113,
    r: 1.02825,
    fill: "#7038A7"
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: 66.0673,
    cy: 59.0104,
    r: 1.02825,
    fill: "#7038A7"
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    cx: 66.0673,
    cy: 62.6096,
    r: 1.02825,
    fill: "#7038A7"
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    cx: 66.0673,
    cy: 66.2079,
    r: 1.02825,
    fill: "#7038A7"
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    cx: 66.0673,
    cy: 69.8071,
    r: 1.02825,
    fill: "#7038A7"
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    cx: 55.2704,
    cy: 37.404,
    r: 1.02825,
    fill: "#7038A7"
  })), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    cx: 55.2704,
    cy: 41.0021,
    r: 1.02825,
    fill: "#7038A7"
  })), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    cx: 55.2704,
    cy: 44.6008,
    r: 1.02825,
    fill: "#7038A7"
  })), _circle29 || (_circle29 = /*#__PURE__*/React.createElement("circle", {
    cx: 55.2704,
    cy: 48.1999,
    r: 1.02825,
    fill: "#7038A7"
  })), _circle30 || (_circle30 = /*#__PURE__*/React.createElement("circle", {
    cx: 55.2704,
    cy: 51.7983,
    r: 1.02825,
    fill: "#7038A7"
  })), _circle31 || (_circle31 = /*#__PURE__*/React.createElement("circle", {
    cx: 69.6689,
    cy: 37.403,
    r: 1.02825,
    fill: "#7038A7"
  })), _circle32 || (_circle32 = /*#__PURE__*/React.createElement("circle", {
    cx: 69.6689,
    cy: 41.0021,
    r: 1.02825,
    fill: "#7038A7"
  })), _circle33 || (_circle33 = /*#__PURE__*/React.createElement("circle", {
    cx: 69.6689,
    cy: 44.6008,
    r: 1.02825,
    fill: "#7038A7"
  })), _circle34 || (_circle34 = /*#__PURE__*/React.createElement("circle", {
    cx: 69.6689,
    cy: 48.1999,
    r: 1.02825,
    fill: "#7038A7"
  })), _circle35 || (_circle35 = /*#__PURE__*/React.createElement("circle", {
    cx: 69.6689,
    cy: 51.7983,
    r: 1.02825,
    fill: "#7038A7"
  })), _circle36 || (_circle36 = /*#__PURE__*/React.createElement("circle", {
    cx: 58.8681,
    cy: 37.403,
    r: 1.02825,
    fill: "#7038A7"
  })), _circle37 || (_circle37 = /*#__PURE__*/React.createElement("circle", {
    cx: 58.8681,
    cy: 41.0021,
    r: 1.02825,
    fill: "#7038A7"
  })), _circle38 || (_circle38 = /*#__PURE__*/React.createElement("circle", {
    cx: 58.8681,
    cy: 44.6008,
    r: 1.02825,
    fill: "#7038A7"
  })), _circle39 || (_circle39 = /*#__PURE__*/React.createElement("circle", {
    cx: 58.8681,
    cy: 48.1999,
    r: 1.02825,
    fill: "#7038A7"
  })), _circle40 || (_circle40 = /*#__PURE__*/React.createElement("circle", {
    cx: 58.8681,
    cy: 51.7983,
    r: 1.02825,
    fill: "#7038A7"
  })), _circle41 || (_circle41 = /*#__PURE__*/React.createElement("circle", {
    cx: 62.4697,
    cy: 37.403,
    r: 1.02825,
    fill: "#7038A7"
  })), _circle42 || (_circle42 = /*#__PURE__*/React.createElement("circle", {
    cx: 62.4697,
    cy: 41.0021,
    r: 1.02825,
    fill: "#7038A7"
  })), _circle43 || (_circle43 = /*#__PURE__*/React.createElement("circle", {
    cx: 62.4697,
    cy: 44.6008,
    r: 1.02825,
    fill: "#7038A7"
  })), _circle44 || (_circle44 = /*#__PURE__*/React.createElement("circle", {
    cx: 62.4697,
    cy: 48.1999,
    r: 1.02825,
    fill: "#7038A7"
  })), _circle45 || (_circle45 = /*#__PURE__*/React.createElement("circle", {
    cx: 62.4697,
    cy: 51.7983,
    r: 1.02825,
    fill: "#7038A7"
  })), _circle46 || (_circle46 = /*#__PURE__*/React.createElement("circle", {
    cx: 66.0673,
    cy: 37.403,
    r: 1.02825,
    fill: "#7038A7"
  })), _circle47 || (_circle47 = /*#__PURE__*/React.createElement("circle", {
    cx: 66.0673,
    cy: 41.0021,
    r: 1.02825,
    fill: "#7038A7"
  })), _circle48 || (_circle48 = /*#__PURE__*/React.createElement("circle", {
    cx: 66.0673,
    cy: 44.6008,
    r: 1.02825,
    fill: "#7038A7"
  })), _circle49 || (_circle49 = /*#__PURE__*/React.createElement("circle", {
    cx: 66.0673,
    cy: 48.1999,
    r: 1.02825,
    fill: "#7038A7"
  })), _circle50 || (_circle50 = /*#__PURE__*/React.createElement("circle", {
    cx: 66.0673,
    cy: 51.7983,
    r: 1.02825,
    fill: "#7038A7"
  })), _circle51 || (_circle51 = /*#__PURE__*/React.createElement("circle", {
    cx: 73.2822,
    cy: 55.4123,
    r: 1.02825,
    fill: "#7038A7"
  })), _circle52 || (_circle52 = /*#__PURE__*/React.createElement("circle", {
    cx: 73.2822,
    cy: 59.0112,
    r: 1.02825,
    fill: "#7038A7"
  })), _circle53 || (_circle53 = /*#__PURE__*/React.createElement("circle", {
    cx: 73.2822,
    cy: 62.6103,
    r: 1.02825,
    fill: "#7038A7"
  })), _circle54 || (_circle54 = /*#__PURE__*/React.createElement("circle", {
    cx: 73.2822,
    cy: 66.2089,
    r: 1.02825,
    fill: "#7038A7"
  })), _circle55 || (_circle55 = /*#__PURE__*/React.createElement("circle", {
    cx: 73.2822,
    cy: 69.808,
    r: 1.02825,
    fill: "#7038A7"
  })), _circle56 || (_circle56 = /*#__PURE__*/React.createElement("circle", {
    cx: 87.6806,
    cy: 55.412,
    r: 1.02825,
    fill: "#7038A7"
  })), _circle57 || (_circle57 = /*#__PURE__*/React.createElement("circle", {
    cx: 87.6806,
    cy: 59.0112,
    r: 1.02825,
    fill: "#7038A7"
  })), _circle58 || (_circle58 = /*#__PURE__*/React.createElement("circle", {
    cx: 87.6806,
    cy: 62.6103,
    r: 1.02825,
    fill: "#7038A7"
  })), _circle59 || (_circle59 = /*#__PURE__*/React.createElement("circle", {
    cx: 87.6806,
    cy: 66.2089,
    r: 1.02825,
    fill: "#7038A7"
  })), _circle60 || (_circle60 = /*#__PURE__*/React.createElement("circle", {
    cx: 87.6806,
    cy: 69.808,
    r: 1.02825,
    fill: "#7038A7"
  })), _circle61 || (_circle61 = /*#__PURE__*/React.createElement("circle", {
    cx: 76.8798,
    cy: 55.412,
    r: 1.02825,
    fill: "#7038A7"
  })), _circle62 || (_circle62 = /*#__PURE__*/React.createElement("circle", {
    cx: 76.8798,
    cy: 59.0112,
    r: 1.02825,
    fill: "#7038A7"
  })), _circle63 || (_circle63 = /*#__PURE__*/React.createElement("circle", {
    cx: 76.8798,
    cy: 62.6103,
    r: 1.02825,
    fill: "#7038A7"
  })), _circle64 || (_circle64 = /*#__PURE__*/React.createElement("circle", {
    cx: 76.8798,
    cy: 66.2089,
    r: 1.02825,
    fill: "#7038A7"
  })), _circle65 || (_circle65 = /*#__PURE__*/React.createElement("circle", {
    cx: 76.8798,
    cy: 69.808,
    r: 1.02825,
    fill: "#7038A7"
  })), _circle66 || (_circle66 = /*#__PURE__*/React.createElement("circle", {
    cx: 80.4814,
    cy: 55.412,
    r: 1.02825,
    fill: "#7038A7"
  })), _circle67 || (_circle67 = /*#__PURE__*/React.createElement("circle", {
    cx: 80.4814,
    cy: 59.0112,
    r: 1.02825,
    fill: "#7038A7"
  })), _circle68 || (_circle68 = /*#__PURE__*/React.createElement("circle", {
    cx: 80.4814,
    cy: 62.6103,
    r: 1.02825,
    fill: "#7038A7"
  })), _circle69 || (_circle69 = /*#__PURE__*/React.createElement("circle", {
    cx: 80.4814,
    cy: 66.2089,
    r: 1.02825,
    fill: "#7038A7"
  })), _circle70 || (_circle70 = /*#__PURE__*/React.createElement("circle", {
    cx: 80.4814,
    cy: 69.808,
    r: 1.02825,
    fill: "#7038A7"
  })), _circle71 || (_circle71 = /*#__PURE__*/React.createElement("circle", {
    cx: 84.079,
    cy: 55.412,
    r: 1.02825,
    fill: "#7038A7"
  })), _circle72 || (_circle72 = /*#__PURE__*/React.createElement("circle", {
    cx: 84.079,
    cy: 59.0112,
    r: 1.02825,
    fill: "#7038A7"
  })), _circle73 || (_circle73 = /*#__PURE__*/React.createElement("circle", {
    cx: 84.079,
    cy: 62.6103,
    r: 1.02825,
    fill: "#7038A7"
  })), _circle74 || (_circle74 = /*#__PURE__*/React.createElement("circle", {
    cx: 84.079,
    cy: 66.2089,
    r: 1.02825,
    fill: "#7038A7"
  })), _circle75 || (_circle75 = /*#__PURE__*/React.createElement("circle", {
    cx: 84.079,
    cy: 69.808,
    r: 1.02825,
    fill: "#7038A7"
  })), _circle76 || (_circle76 = /*#__PURE__*/React.createElement("circle", {
    cx: 73.2822,
    cy: 37.4042,
    r: 1.02825,
    fill: "#7038A7"
  })), _circle77 || (_circle77 = /*#__PURE__*/React.createElement("circle", {
    cx: 73.2822,
    cy: 41.0024,
    r: 1.02825,
    fill: "#7038A7"
  })), _circle78 || (_circle78 = /*#__PURE__*/React.createElement("circle", {
    cx: 73.2822,
    cy: 44.6008,
    r: 1.02825,
    fill: "#7038A7"
  })), _circle79 || (_circle79 = /*#__PURE__*/React.createElement("circle", {
    cx: 73.2822,
    cy: 48.1999,
    r: 1.02825,
    fill: "#7038A7"
  })), _circle80 || (_circle80 = /*#__PURE__*/React.createElement("circle", {
    cx: 73.2822,
    cy: 51.7985,
    r: 1.02825,
    fill: "#7038A7"
  })), _circle81 || (_circle81 = /*#__PURE__*/React.createElement("circle", {
    cx: 87.6806,
    cy: 37.4033,
    r: 1.02825,
    fill: "#7038A7"
  })), _circle82 || (_circle82 = /*#__PURE__*/React.createElement("circle", {
    cx: 87.6806,
    cy: 41.0024,
    r: 1.02825,
    fill: "#7038A7"
  })), _circle83 || (_circle83 = /*#__PURE__*/React.createElement("circle", {
    cx: 87.6806,
    cy: 44.6008,
    r: 1.02825,
    fill: "#7038A7"
  })), _circle84 || (_circle84 = /*#__PURE__*/React.createElement("circle", {
    cx: 87.6806,
    cy: 48.1999,
    r: 1.02825,
    fill: "#7038A7"
  })), _circle85 || (_circle85 = /*#__PURE__*/React.createElement("circle", {
    cx: 87.6806,
    cy: 51.7985,
    r: 1.02825,
    fill: "#7038A7"
  })), _circle86 || (_circle86 = /*#__PURE__*/React.createElement("circle", {
    cx: 76.8798,
    cy: 37.4033,
    r: 1.02825,
    fill: "#7038A7"
  })), _circle87 || (_circle87 = /*#__PURE__*/React.createElement("circle", {
    cx: 76.8798,
    cy: 41.0024,
    r: 1.02825,
    fill: "#7038A7"
  })), _circle88 || (_circle88 = /*#__PURE__*/React.createElement("circle", {
    cx: 76.8798,
    cy: 44.6008,
    r: 1.02825,
    fill: "#7038A7"
  })), _circle89 || (_circle89 = /*#__PURE__*/React.createElement("circle", {
    cx: 76.8798,
    cy: 48.1999,
    r: 1.02825,
    fill: "#7038A7"
  })), _circle90 || (_circle90 = /*#__PURE__*/React.createElement("circle", {
    cx: 76.8798,
    cy: 51.7985,
    r: 1.02825,
    fill: "#7038A7"
  })), _circle91 || (_circle91 = /*#__PURE__*/React.createElement("circle", {
    cx: 80.4814,
    cy: 37.4033,
    r: 1.02825,
    fill: "#7038A7"
  })), _circle92 || (_circle92 = /*#__PURE__*/React.createElement("circle", {
    cx: 80.4814,
    cy: 41.0024,
    r: 1.02825,
    fill: "#7038A7"
  })), _circle93 || (_circle93 = /*#__PURE__*/React.createElement("circle", {
    cx: 80.4814,
    cy: 44.6008,
    r: 1.02825,
    fill: "#7038A7"
  })), _circle94 || (_circle94 = /*#__PURE__*/React.createElement("circle", {
    cx: 80.4814,
    cy: 48.1999,
    r: 1.02825,
    fill: "#7038A7"
  })), _circle95 || (_circle95 = /*#__PURE__*/React.createElement("circle", {
    cx: 80.4814,
    cy: 51.7985,
    r: 1.02825,
    fill: "#7038A7"
  })), _circle96 || (_circle96 = /*#__PURE__*/React.createElement("circle", {
    cx: 84.079,
    cy: 37.4033,
    r: 1.02825,
    fill: "#7038A7"
  })), _circle97 || (_circle97 = /*#__PURE__*/React.createElement("circle", {
    cx: 84.079,
    cy: 41.0024,
    r: 1.02825,
    fill: "#7038A7"
  })), _circle98 || (_circle98 = /*#__PURE__*/React.createElement("circle", {
    cx: 84.079,
    cy: 44.6008,
    r: 1.02825,
    fill: "#7038A7"
  })), _circle99 || (_circle99 = /*#__PURE__*/React.createElement("circle", {
    cx: 84.079,
    cy: 48.1999,
    r: 1.02825,
    fill: "#7038A7"
  })), _circle100 || (_circle100 = /*#__PURE__*/React.createElement("circle", {
    cx: 84.079,
    cy: 51.7985,
    r: 1.02825,
    fill: "#7038A7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M190.817 54.2434C165.79 54.2434 145.499 70.2359 145.499 89.9553C145.499 104.211 156.138 116.482 171.444 122.211C171.144 122.823 170.872 123.463 170.526 124.063C167.526 129.083 163.141 132.89 157.926 135.452C169.493 136.277 180.196 132.815 187.257 125.529C188.434 125.598 189.617 125.673 190.817 125.673C215.838 125.673 236.117 109.681 236.117 89.9553C236.117 70.2359 215.838 54.2434 190.817 54.2434Z",
    fill: "#FF849C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M145.505 90.0571C145.568 104.261 156.172 116.475 171.444 122.192C171.144 122.804 170.872 123.444 170.526 124.044C167.526 129.063 163.141 132.871 157.926 135.433C169.493 136.258 180.195 132.796 187.257 125.509C188.434 125.579 189.617 125.654 190.817 125.654C215.792 125.654 236.036 109.725 236.117 90.0571H145.505Z",
    fill: "#FF3F65"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M194.638 75.3032L193.294 94.3192H188.325L186.98 75.3032H194.638ZM194.638 101.171C194.638 102.172 194.285 103.01 193.579 103.685C192.846 104.334 191.923 104.658 190.809 104.658C189.696 104.658 188.786 104.334 188.08 103.685C187.347 103.01 186.98 102.172 186.98 101.171C186.98 100.117 187.347 99.2793 188.08 98.6576C188.786 98.0089 189.696 97.6845 190.809 97.6845C191.923 97.6845 192.846 98.0089 193.579 98.6576C194.285 99.2793 194.638 100.117 194.638 101.171Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M151.849 138.429L152.206 138.998L151.609 141.237C151.609 141.237 149.044 144.485 147.651 145.352C146.258 146.22 142.457 151.308 141.837 151.784C141.219 152.254 137.977 150.667 137.977 150.667C137.977 150.667 143.014 146.521 144.876 144.698C146.74 142.879 148.527 139.342 149.233 138.601C150.434 137.333 150.975 136.625 150.975 136.625C150.975 136.625 151.541 137.378 149.767 139.477C149.298 140.032 150.148 140.276 150.148 140.276L151.849 138.429Z",
    fill: "#F7B68B"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M107.078 293.148C109.613 298.576 112.827 302.437 114.257 301.766C115.698 301.101 114.808 296.156 112.278 290.725C109.753 285.291 106.54 281.429 105.105 282.099C103.668 282.767 104.553 287.712 107.078 293.148Z",
    fill: "#3D3D3D"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M108.592 120.688C108.592 120.688 108.763 122.261 111.845 123.008C114.932 123.758 119.185 120.7 119.559 113.382C119.93 106.061 124.556 107.182 124.79 101.615C125.016 96.0504 122.622 92.405 118.484 94.9778C114.341 97.5507 111.284 97.8339 112.427 99.8975C113.567 101.964 117.991 102.778 118.049 100.241C118.107 97.6983 107.875 84.9185 100.469 87.2925C95.4703 88.8922 94.5549 90.4588 96.0959 95.4297C97.2209 99.051 96.9257 102.275 92.1798 103.938C86.08 106.073 87.9321 108.339 89.924 110.032C92.8677 112.533 97.6317 114.199 96.2617 117.699C94.8879 121.2 102.823 122.098 108.592 120.688Z",
    fill: "#7038A7"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M111.589 126.265C115.112 128.127 112.086 128.142 111.847 128.407C110.405 129.995 95.8099 126.856 95.0214 124.617C94.8898 124.241 101.865 123.668 101.92 123.397C102.545 120.273 102.884 117.613 102.254 114.028C102.308 113.757 102.526 113.552 102.738 113.567C104.027 113.696 105.323 113.796 106.617 113.922C106.834 113.947 109.327 114.694 108.684 115.911C108.187 119.327 107.865 124.295 111.589 126.265Z",
    fill: "#EC9568"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M110.908 116.749C110.995 116.637 111.079 116.526 111.163 116.411C111.19 116.375 111.215 116.342 111.243 116.303C111.348 116.158 111.452 116.01 111.551 115.857C111.578 115.815 111.605 115.772 111.631 115.733C111.706 115.616 111.778 115.498 111.855 115.378C111.895 115.312 111.934 115.242 111.974 115.176C112.032 115.077 112.092 114.974 112.152 114.866C112.192 114.793 112.231 114.721 112.272 114.652C112.348 114.51 112.42 114.372 112.49 114.23C112.543 114.125 112.597 114.013 112.652 113.905C112.7 113.808 112.749 113.709 112.793 113.609C112.839 113.51 112.886 113.405 112.933 113.302C112.971 113.215 113.011 113.127 113.046 113.037C113.078 112.965 113.107 112.895 113.141 112.823C113.141 112.82 113.144 112.817 113.144 112.814C113.656 111.579 114.709 105.376 114.453 102.215C114.424 101.833 113.998 101.032 113.642 101.399C107.023 108.214 101.904 98.2358 102.108 107.545V107.554C102.104 107.578 102.056 108.361 102.042 108.72C102.038 108.753 102.038 108.783 102.038 108.813C102.03 109.178 102.024 109.542 102.03 109.892C102.03 109.916 102.031 109.937 102.031 109.958C102.038 110.32 102.049 110.675 102.074 111.025C102.074 111.037 102.074 111.049 102.074 111.058C102.359 115.495 103.93 118.788 106.322 119.222C107.718 119.478 109.175 118.725 110.495 117.243C110.506 117.231 110.515 117.216 110.528 117.207C110.625 117.092 110.723 116.975 110.82 116.857C110.849 116.821 110.881 116.785 110.908 116.749Z",
    fill: "#F7B68B"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M149.336 141.29C149.336 141.29 149.786 141.853 150.227 141.513C150.962 140.958 151.866 139.325 152.168 138.732C152.498 138.066 153.561 134.671 153.561 134.671C153.561 134.671 152.469 135.379 152.039 136.744C151.408 138.732 149.336 141.29 149.336 141.29Z",
    fill: "#EC9568"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M150.352 140.96C151.368 140.117 151.717 138.601 151.712 136.712C151.708 134.926 152.606 134.233 152.606 134.233C152.606 134.233 152.729 135.387 152.453 138.164C152.376 138.945 152.246 139.791 151.903 140.481C150.872 142.566 147.738 143.132 150.352 140.96Z",
    fill: "#EC9568"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M87.5844 176.578C89.215 175.971 93.0905 182.492 94.2333 187.809C96.4723 198.233 96.4927 203.758 96.0019 214.666C95.2258 231.973 94.2575 259.509 93.4357 271.147C92.6922 281.639 94.4167 294.559 88.598 291.633C91.4716 277.6 89.2008 255.135 87.6524 243.268C82.3732 202.743 82.5599 178.432 87.5844 176.578Z",
    fill: "#F7B68B"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M116.514 191.675C116.504 188.87 116.475 186.111 116.424 183.386C115.273 179.203 114.004 176.872 112.674 176.92C107.645 177.097 99.0048 197.956 103.896 252.515C104.038 254.126 104.167 265.782 104.998 275C105.581 281.469 107.178 285.216 106.498 290C110.461 260.791 116.691 233.239 116.514 191.675Z",
    fill: "#F7B68B"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M107.471 291.454C108.831 295.658 111.719 298.698 113.139 297.998C114.556 297.294 114.037 293.693 111.908 289.819C109.205 284.927 108.179 283.525 107.946 280.013C107.735 276.719 102.353 275.651 107.471 291.454Z",
    fill: "#F7B68B"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M79.2043 289.302C79.2043 289.302 80.6247 288.689 84.5498 287.945C86.8491 287.512 88.5849 287.525 89.4125 286.665C90.7727 285.242 90.0185 281.794 90.6832 281.949C93.9348 282.696 95.0587 290.289 93.16 291.239C91.2686 292.187 80.5572 290.922 79.6753 290.856C78.7978 290.79 78.9343 289.094 79.2043 289.302Z",
    fill: "#F7B68B"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M81.7265 288.689C80.8944 291.177 88.7969 290.874 90.8778 290.393C92.8673 289.942 94.1248 289.857 94.1248 289.857L94.363 289.862L94.3797 290.048C94.251 291.445 94.6929 293.364 92.4545 293.158L78.4481 291.867C66.987 290.811 81.7482 288.629 81.7265 288.689Z",
    fill: "#3D3D3D"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M77.001 145.895C81.3972 150.028 85.3683 168.851 85.3683 168.851C85.3683 168.851 84.8491 176.314 75.0954 152.746C72.166 145.669 75.9193 144.876 77.001 145.895Z",
    fill: "#F7B68B"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M122.387 141.634C125.708 147.099 123.053 166.178 123.053 166.178C123.053 166.178 119.67 172.984 117.702 147.361C117.111 139.67 121.57 140.284 122.387 141.634Z",
    fill: "#F7B68B"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M121.321 164.611C124.412 157.839 144.24 145.568 144.24 145.568C144.24 145.568 152.858 143.131 129.743 164.03C122.804 170.305 120.559 166.28 121.321 164.611Z",
    fill: "#F7B68B"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M114.171 152.276L91.4751 150.586L90.3516 123.638L118.574 128.175L114.171 152.276Z",
    fill: "#E91171"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M81.5397 230.942C94.4964 229.846 107.455 228.749 120.414 227.653C128.501 203.831 123.681 176.434 114.381 151.995C106.759 151.351 99.1329 150.703 91.5059 150.058C82.5196 175.347 74.079 204.588 81.5397 230.942Z",
    fill: "#E91171"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M78.723 149.709L95.0065 126.265C94.7659 125.578 94.3283 124.957 93.7085 124.499L93.2913 124.189C91.6573 122.99 89.3976 123.376 88.2326 125.054L74 145.54L78.723 149.709Z",
    fill: "#E91171"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M118.534 157.641L116.039 128.921C116.582 128.457 117.266 128.15 118.023 128.081L118.538 128.033C120.533 127.846 122.293 129.367 122.474 131.419L124.653 156.514L118.534 157.641Z",
    fill: "#E91171"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M85.8452 173.951C85.7183 174.376 85.2833 174.608 84.874 174.478L83.8858 174.159C83.4771 174.026 83.2505 173.577 83.3803 173.156L84.769 168.576C84.8947 168.152 85.3327 167.917 85.7414 168.049L86.7316 168.369C87.1374 168.501 87.3678 168.95 87.2368 169.372L85.8452 173.951Z",
    fill: "#F7B68B"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M151.129 141.784C151.129 141.784 152.53 140.205 152.662 139.139C152.751 138.395 152.611 134.831 152.611 134.831C152.611 134.831 151.828 135.879 151.876 137.313C151.955 139.404 151.129 141.784 151.129 141.784Z",
    fill: "#F7B68B"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgScreenOfDeath, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/screen-of-death.7850b696.svg";
export { ForwardRef as ReactComponent };